var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5C6.67157 5 6 5.67157 6 6.5C6 7.32843 6.67157 8 7.5 8C8.32843 8 9 7.32843 9 6.5C9 5.67157 8.32843 5 7.5 5Z",
    fill: "#063085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99999 1.99988L8 1.99989V0H7V1.9999L5.99991 1.9999C2.68625 1.99993 9.17923e-06 4.68619 0 7.99985C-9.179e-06 11.3135 2.68627 13.9998 5.99996 13.9998H9.00004C9.13059 13.9998 9.26024 13.9957 9.38884 13.9874L13.3788 14.9849C13.5492 15.0275 13.7294 14.9776 13.8536 14.8534C13.9778 14.7292 14.0277 14.549 13.9851 14.3786L13.4081 12.0704C14.3958 11.0012 15 9.57071 15 7.99985C15 4.68614 12.3137 1.99985 8.99999 1.99988ZM5 6.5C5 5.11929 6.11929 4 7.5 4C8.88071 4 10 5.11929 10 6.5C10 7.88071 8.88071 9 7.5 9C6.11929 9 5 7.88071 5 6.5ZM7.49998 12C6.43628 12 5.45756 11.6303 4.68726 11.0128L5.31272 10.2326C5.91201 10.713 6.67179 11 7.49998 11C8.32816 11 9.08794 10.713 9.68723 10.2326L10.3127 11.0128C9.54239 11.6303 8.56367 12 7.49998 12Z",
    fill: "#063085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.40c9d50b2a14b41f78ec95604b69de2c.svg";
export { ForwardRef as ReactComponent };